import * as _ from 'lodash';

export const searchSegment = (status: number): any => {
  let segment = 'working';
  if (_.indexOf([4, 5], status) > -1) {
    segment = 'import-review-pies';
  } else if ( _.indexOf([8, 10], status) > -1) {
    segment = 'published';
  } else if ( _.indexOf([6], status) > -1) {
    segment = 'view-export';
  }
  return segment;
};
